'use client';

import { useState } from 'react';
import { cn } from '@/utils/cn';
import { TrustpilotIcon } from '../icons/socials/TrustpilotIcon';
import { AuthenticationButtons } from './AuthenticationButtons';
import { HamburgerMenu } from './HamburgerMenu';
import { LogoWithLink } from './LogoWithLink';
import { DesktopNavigation } from './Navigation/DesktopNavigation';
import { MobileNavigation } from './Navigation/MobileNavigation';

export const HEADER_ID = 'header';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);

  return (
    <header
      className={cn(
        'sticky inset-x-0 top-0 z-50 flex w-full flex-col bg-transparent text-white'
      )}
      id="header"
    >
      <div className="flex h-10 items-center justify-center bg-card-bg sm:hidden">
        <a
          className="inline-flex items-center gap-1.5"
          href="https://www.trustpilot.com/review/gocore.gg"
          rel="noopener"
          target="_blank"
        >
          <span className="font-normal text-sm/6.5 text-white">
            See our{' '}
            <span className="font-semibold text-light-blue">13 reviews</span> on{' '}
          </span>
          <TrustpilotIcon />
          <span className="font-normal text-sm/6.5 text-white">Trustpilot</span>
        </a>
      </div>

      {/* Header Top */}
      <div className="flex h-16 w-full flex-row bg-dark-gray">
        <div className="container mx-auto max-w-(--breakpoint-xl) px-4">
          <div className="flex h-full items-center justify-between">
            <div className="flex items-center gap-4 sm:gap-6 lg:gap-8">
              <LogoWithLink />
              <DesktopNavigation />
            </div>
            <div className="flex items-center gap-2 sm:gap-4">
              <AuthenticationButtons />
              <HamburgerMenu
                isOpen={mobileMenuOpen}
                onClick={toggleMobileMenu}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      <MobileNavigation
        isMenuOpen={mobileMenuOpen}
        toggleMenu={toggleMobileMenu}
      />
    </header>
  );
};

export default Header;
